import { __awaiter } from "tslib";
import React, { useEffect, useState } from 'react';
import { branch, compose, renderComponent } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withLifecycle from '@hocs/with-lifecycle';
import { components as clientComponents } from 'mage-client';
import { Link, Loader } from '@klarna/bubble-ui';
import copyToClipboard from '@/utils/copyToClipboard';
import { getCountries } from '@/selectors/options';
import capabilities from '@/selectors/capabilities';
import { getPlatforms } from '@/selectors/platforms';
import { CAPS } from '@/constants';
import { ContractOnboardingType } from '@/bpc/mf-fields/enm/ContractOnboardingType';
import { MerchantCreator } from './MerchantCreator';
import './style.css';
const componentPropTypes = {
    contractOnboardingTypes: PropTypes.array,
    countries: PropTypes.array,
    platforms: PropTypes.array,
};
const Component = ({ countries, platforms, contractOnboardingTypes }) => {
    const [widgetUrl, setWidgetUrl] = useState(null);
    useEffect(() => {
        if (widgetUrl) {
            copyToClipboard(widgetUrl);
        }
    }, [widgetUrl]);
    return (React.createElement("div", { className: "app" },
        React.createElement("div", { className: "merchant-creator" },
            React.createElement(MerchantCreator, { countries: countries !== null && countries !== void 0 ? countries : [], platforms: platforms !== null && platforms !== void 0 ? platforms : [], contractOnboardingTypes: contractOnboardingTypes !== null && contractOnboardingTypes !== void 0 ? contractOnboardingTypes : [], setWidgetUrl: setWidgetUrl })),
        widgetUrl && (React.createElement("div", { className: "widget-frame" },
            React.createElement(Link, { href: widgetUrl, target: "_blank", textToken: "text-style/text/labels/body/bold" }, "Click here to open the widget (The link is copied to the clipboard)")))));
};
Component.propTypes = componentPropTypes;
const INIT_CAPS = {
    getOptions: CAPS.V2_OPTIONS_GET,
    getPlatforms: CAPS.V2_PLATFORMS_GET,
};
const getContractOnboardingTypes = () => {
    return Object.entries(ContractOnboardingType).map(([key, value]) => ({
        key,
        id: key,
        label: value,
    }));
};
export const WidgetLinkCreator = compose(clientComponents.withPromiseBasedCapabilities(INIT_CAPS), connect(state => {
    return {
        capsFinished: capabilities.hasFinished(INIT_CAPS)(state),
        countries: getCountries(state),
        platforms: getPlatforms(state),
        contractOnboardingTypes: getContractOnboardingTypes(),
    };
}), withLifecycle({
    onWillMount(_a) {
        return __awaiter(this, arguments, void 0, function* ({ getOptions, getPlatforms }) {
            yield Promise.all([getOptions(), getPlatforms()]);
        });
    },
}), branch(
// @ts-expect-error: FIXME
({ capsFinished }) => !capsFinished, renderComponent(() => React.createElement(Loader, null))))(Component);
